export default __webpack_public_path__ + "static/media/SCISSOR-MENU-ICON-.21afd071.png";